<template>
  <div class="space-y-6">
    <!-- Mõõdud -->
    <fieldset>
      <legend :class="legendClass">Mõõdud</legend>
      <div
        class="mt-3 grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)_auto_minmax(0,1fr)] items-end gap-x-2"
      >
        <div>
          <label for="mõõt" :class="labelClass">Laius (mm)</label>
          <input
            id="mõõt"
            ref="widthInput"
            v-model.trim="mõõt"
            type="number"
            :class="[inputClass, 'no-spin text-center']"
            placeholder="205"
            min="0"
            step="any"
            inputmode="decimal"
            @input="autoAdvance($event, 'mõõt', 3, 'aspectInput')"
          />
        </div>
        <span class="pb-2 text-lg text-slate-300" aria-hidden="true">/</span>
        <div>
          <label for="aspectRatio" :class="labelClass">Kõrgus (%)</label>
          <input
            id="aspectRatio"
            ref="aspectInput"
            v-model.trim="aspectRatio"
            type="number"
            :class="[inputClass, 'no-spin text-center']"
            placeholder="55"
            min="0"
            step="any"
            inputmode="decimal"
            @input="autoAdvance($event, 'aspectRatio', 2, 'diameterInput')"
          />
        </div>
        <span
          class="pb-2.5 text-sm font-semibold text-slate-400"
          aria-hidden="true"
          >R</span
        >
        <div>
          <label for="diameeter" :class="labelClass">Diameeter</label>
          <input
            id="diameeter"
            ref="diameterInput"
            v-model.trim="diameeter"
            type="number"
            :class="[inputClass, 'no-spin text-center']"
            placeholder="17"
            min="0"
            step="any"
            inputmode="decimal"
          />
        </div>
      </div>
    </fieldset>

    <!-- Tootja ja mudel -->
    <fieldset>
      <legend :class="legendClass">Tootja ja mudel</legend>
      <div class="mt-3 grid gap-3" :class="{ 'sm:grid-cols-2': !compact }">
        <div>
          <label for="tootja" :class="labelClass">Tootja</label>
          <select id="tootja" v-model="tootja" :class="selectClass">
            <option
              v-for="option in brandOptions"
              :key="option.value || option.label"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
        <div>
          <label for="mudel" :class="labelClass">Mudel</label>
          <input
            id="mudel"
            v-model="mudel"
            type="text"
            :class="inputClass"
            placeholder="Nt. TRAILERMAXX"
          />
        </div>
      </div>
    </fieldset>

    <!-- Rehvi tüüp -->
    <fieldset>
      <legend :class="legendClass">Rehvi tüüp</legend>
      <div
        class="mt-3 grid grid-cols-2 gap-2"
        :class="{ 'sm:grid-cols-3': !compact }"
      >
        <label :class="chipClass(suverehv)">
          <input v-model="suverehv" type="checkbox" :class="checkboxClass" />
          Suverehv
        </label>
        <label :class="chipClass(talverehv)">
          <input v-model="talverehv" type="checkbox" :class="checkboxClass" />
          Talverehv
        </label>
        <label :class="chipClass(naastrehv)">
          <input v-model="naastrehv" type="checkbox" :class="checkboxClass" />
          Naastrehv
        </label>
        <label :class="chipClass(offroad)">
          <input v-model="offroad" type="checkbox" :class="checkboxClass" />
          Offroad
        </label>
        <label :class="chipClass(ringrada)">
          <input v-model="ringrada" type="checkbox" :class="checkboxClass" />
          Ringrada
        </label>
        <label :class="chipClass(taastatud)">
          <input v-model="taastatud" type="checkbox" :class="checkboxClass" />
          Taastatud
        </label>
      </div>
    </fieldset>

    <!-- Muud näitajad -->
    <fieldset>
      <legend :class="legendClass">Muud näitajad</legend>
      <div class="mt-3">
        <label for="lisi" :class="labelClass"
          >Li/Si (koormus- ja kiirusindeks)</label
        >
        <input
          id="lisi"
          v-model="lisi"
          type="text"
          :class="inputClass"
          placeholder="Nt. 96W"
        />
      </div>
    </fieldset>
  </div>
</template>

<script>
import { chipClass, fieldModels, formClasses } from "./formShared";

export default {
  name: "TyreFilterForm",
  props: {
    modelValue: { type: Object, required: true },
    brandOptions: { type: Array, default: () => [] },
    // Narrow sidebar layout once results are shown.
    compact: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  data() {
    return { ...formClasses };
  },
  computed: {
    ...fieldModels([
      "tootja",
      "mudel",
      "mõõt",
      "aspectRatio",
      "diameeter",
      "lisi",
      "suverehv",
      "talverehv",
      "naastrehv",
      "offroad",
      "ringrada",
      "taastatud",
    ]),
  },
  methods: {
    chipClass,
    // Reads the DOM value because the v-model update reaches modelValue
    // only after the parent re-renders.
    autoAdvance(event, fieldKey, threshold, nextRefName) {
      const digits = (event.target.value ?? "").toString().replace(/\D/g, "");
      if (digits.length >= threshold) {
        this[fieldKey] = digits.slice(0, threshold);
        this.$nextTick(() => {
          const next = this.$refs[nextRefName];
          if (next && typeof next.focus === "function") {
            next.focus();
            if (typeof next.select === "function") {
              next.select();
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped>
/* Hide number-input spinners so the compact size fields stay clean. */
.no-spin {
  -moz-appearance: textfield;
  appearance: textfield;
}

.no-spin::-webkit-outer-spin-button,
.no-spin::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
